import { Plus, RotateCw } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { ControlBar, ControlBarGroup } from '@/components/ui/ControlBar'
import { cn } from '@/lib/utils'
import { Segmented } from '@/components/ui/Segmented'
import { Select, type SelectOption } from '@/components/ui/Select'
import type { Platform } from '@/models'

const PLATFORMS = [
  { value: 'ios', label: 'iOS' },
  { value: 'android', label: 'Android' },
] as const satisfies readonly SelectOption<Platform>[]

interface VersionToolbarProps {
  platform: Platform
  onPlatformChange: (platform: Platform) => void
  versionOptions: readonly SelectOption<string>[]
  versionId: string
  onVersionChange: (versionId: string) => void
  onRefresh: () => void
  onNewRelease: () => void
  refreshing?: boolean
}

export function VersionToolbar({
  platform,
  onPlatformChange,
  versionOptions,
  versionId,
  onVersionChange,
  onRefresh,
  onNewRelease,
  refreshing,
}: VersionToolbarProps) {
  return (
    <ControlBar>
      <ControlBarGroup>
        <Segmented
          aria-label="Platform"
          options={PLATFORMS}
          value={platform}
          onValueChange={onPlatformChange}
        />

        <Select
          aria-label="Version"
          options={versionOptions}
          value={versionId}
          onValueChange={onVersionChange}
          triggerClassName="min-w-60 bg-bg-elev"
        />

        <Button
          variant="ghost"
          size="icon"
          onClick={onRefresh}
          disabled={refreshing}
          aria-label={refreshing ? 'Refreshing version details…' : 'Refresh version details'}
          className="hover:bg-bg-elev rounded-lg"
        >
          <RotateCw aria-hidden className={cn(refreshing && 'animate-spin')} />
        </Button>
      </ControlBarGroup>

      <Button onClick={onNewRelease}>
        <Plus aria-hidden />
        New Release
      </Button>
    </ControlBar>
  )
}
